import {
  getMobileVerificationResponseSchema,
  sendMobileVerificationCodeResponseSchema,
} from '@/api/mobileVerification/schemas';
import { apiRequest } from '@/api/utils/api';

export const sendMobileVerificationCode = (mobileNumber: string) =>
  apiRequest({
    url: '/mobile-verification/send',
    method: 'POST',
    data: { mobile: mobileNumber },
    schema: sendMobileVerificationCodeResponseSchema,
  });

export const verifyMobileVerificationCode = (verificationCode: string) =>
  apiRequest<''>({ url: '/mobile-verification/verify', method: 'POST', data: { code: verificationCode } });

export const getMobileVerification = () =>
  apiRequest({
    url: '/mobile-verification',
    method: 'GET',
    schema: getMobileVerificationResponseSchema,
  });
